import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { Information } from './common';
import ProgressService from '../../services/Progress';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import {
  DAY_OF_WEEK,
  DIALOG_WORK_DATE_HEIGHT,
  IS_HOLIDAY,
  IS_NOT_HOLIDAY,
} from '../../utilities/constants';

export class ProgressWorkDatesDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentYear: null,
      currentMonth: null,
      workDates: [],
      currentDay: null,
      today: null,
      progressScheduleCalendars:
        _.get(this.props.progressScheduleItem, 'progress_schedule_calendars') ||
        [],
      start_date: this.props.progressScheduleItem.start_date,
      end_date: this.props.progressScheduleItem.end_date,
      progressScheduleId: this.props.progressScheduleItem.id,
      mainWorkName:
        this.props.progressScheduleItem.main_work_name ||
        this.props.progressScheduleItem.name,
      subWorkName: this.props.progressScheduleItem.sub_work_type_flag
        ? this.props.progressScheduleItem.name
        : this.props.progressScheduleItem.sub_work_name,
      workPlaceName: this.props.progressScheduleItem.work_place_flag
        ? this.props.progressScheduleItem.name
        : '',
    };
    this.field_id = SessionStorageService.getFieldId();
    this.dialog = React.createRef();
    this.isSubmitingFlag = false;
  }

  componentDidMount() {
    this.initCalendar();
    this.setScrollDialog();
  }

  initCalendar = async () => {
    this.props.callApiFlag &&
      (await this.getProgressScheduleCalendars(
        this.state.progressScheduleId,
        this.state.start_date,
        this.state.end_date
      ));
    const startYear = moment(this.state.start_date).year();
    const startMonth = moment(this.state.start_date).month() + 1;
    const year = moment().year();
    const month = moment().month() + 1;
    const date = moment().date();
    const workDates = this.getWorkDates(startYear, startMonth);
    this.setState({
      currentYear: startYear,
      currentMonth: startMonth,
      today: { year, month, date },
      workDates,
    });
  };

  getWorkDates = (year, month) => {
    const progressScheduleCalendars = _.cloneDeep(
      this.state.progressScheduleCalendars
    );
    const date = moment(`${year}/${month}/01`);
    const workDateList = [];
    while (date.month() + 1 === month) {
      const work_date = date.format('YYYY/MM/DD');
      const index = _.findIndex(
        progressScheduleCalendars,
        targetDate => targetDate.target_date === work_date
      );
      let holidayFlag = IS_NOT_HOLIDAY;
      if (index > -1) {
        holidayFlag = IS_HOLIDAY;
      }
      workDateList.push({
        work_date,
        holiday_flag: holidayFlag,
      });
      date.add('day', 1);
    }
    return workDateList;
  };

  getProgressScheduleCalendars = async (
    progressScheduleId,
    startDate,
    endDate
  ) => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const response = await ProgressService.getProgressScheduleCalendars(
      this.field_id,
      {
        progress_schedule_id: progressScheduleId,
        start_date: startDate,
        end_date: endDate,
      }
    );
    this.isSubmitingFlag = false;
    if (response.result) {
      const holidays = _.map(
        _.get(response, 'data.entities.work_dates'),
        item => {
          return {
            target_date: item.target_date,
            manual_setting_flag: item.manual_setting_flag,
          };
        }
      );
      this.setState({ progressScheduleCalendars: holidays });
    }
  };

  handleMoveCalendar(e, movePoint) {
    const nextDate = moment(
      `${this.state.currentYear}/${this.state.currentMonth}/01`
    ).add('months', movePoint);
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month() + 1;

    const workDates = this.getWorkDates(nextYear, nextMonth);
    this.setState({
      currentYear: nextYear,
      currentMonth: nextMonth,
      workDates,
    });
  }

  onClickDate = (e, index) => {
    const workDates = _.cloneDeep(this.state.workDates);
    const oldProgressScheduleCalendars = _.cloneDeep(
      this.state.progressScheduleCalendars
    );
    workDates[index].holiday_flag = workDates[index].holiday_flag
      ? IS_NOT_HOLIDAY
      : IS_HOLIDAY;
    const currentProgressScheduleCalendars = _.map(
      _.filter(workDates, workDate => workDate.holiday_flag),
      workDate => {
        return {
          target_date: workDate.work_date,
          manual_setting_flag: 1,
        };
      }
    );
    _.remove(oldProgressScheduleCalendars, progressScheduleCalendar => {
      const { target_date } = progressScheduleCalendar;
      return moment(target_date).month() + 1 === this.state.currentMonth;
    });
    this.setState({
      workDates,
      progressScheduleCalendars: [
        ...oldProgressScheduleCalendars,
        ...currentProgressScheduleCalendars,
      ],
    });
  };

  handleDayOfWeek = (e, dayWeek) => {
    const workDates = _.cloneDeep(this.state.workDates);
    const oldProgressScheduleCalendars = _.cloneDeep(
      this.state.progressScheduleCalendars
    );
    const isChecked = e.target.checked;
    _.each(workDates, (workDate, index) => {
      if (moment(workDate.work_date).day() === dayWeek) {
        workDates[index].holiday_flag = isChecked ? IS_HOLIDAY : IS_NOT_HOLIDAY;
      }
    });
    const currentProgressScheduleCalendars = _.map(
      _.filter(
        workDates,
        workDate =>
          workDate.holiday_flag &&
          moment(workDate.work_date).isSameOrAfter(this.state.start_date) &&
          moment(workDate.work_date).isSameOrBefore(this.state.end_date)
      ),
      workDate => {
        return {
          target_date: workDate.work_date,
          manual_setting_flag: 1,
        };
      }
    );
    _.remove(oldProgressScheduleCalendars, progressScheduleCalendar => {
      const { target_date } = progressScheduleCalendar;
      return moment(target_date).month() + 1 === this.state.currentMonth;
    });
    this.setState({
      workDates,
      progressScheduleCalendars: [
        ...oldProgressScheduleCalendars,
        ...currentProgressScheduleCalendars,
      ],
    });
  };

  handleCloseDialog = () => {
    this.props.getWorkDays(
      this.props.progressScheduleItem,
      this.state.progressScheduleCalendars
    );
    this.props.onClose();
  };

  setScrollDialog = () => {
    if (this.dialog.current.offsetHeight >= DIALOG_WORK_DATE_HEIGHT) {
      this.dialog.current.classList.add('dialog-scroll');
    }
  };

  render() {
    const startDate = moment(this.state.start_date);
    const endDate = moment(this.state.end_date);
    const startMonth = startDate.month() + 1;
    const startYear = startDate.year();
    const endMonth = endDate.month() + 1;
    const endYear = endDate.year();

    const calenderDateList = () => {
      const { currentYear, currentMonth } = this.state;
      if (currentYear === null || currentMonth === null) {
        return [];
      }
      const currentDate = moment(`${currentYear}/${currentMonth}/01`);
      const month = currentDate.month();
      const date = moment(`${currentYear}/${currentMonth}/01`);
      const calender = [];
      let week = [];
      for (let wd = 0; wd < date.day(); wd++) {
        week.push({});
      }
      while (date.month() === month) {
        if (date.day() === 0 && date.date() !== 1) {
          calender.push(week);
          week = [];
        }
        if (
          (startYear === date.year() &&
            startDate.month() === date.month() &&
            startDate.date() > date.date()) ||
          (endYear === date.year() &&
            endDate.month() === date.month() &&
            endDate.date() < date.date())
        ) {
          week.push({});
        } else {
          week.push({
            key: date.date() - 1,
            year: date.year(),
            month: date.month() + 1,
            date: date.date(),
            day: date.day(),
          });
        }
        date.add('day', 1);
      }
      if (date.day() !== 0) {
        for (let wd = date.day(); wd <= 6; wd++) {
          week.push({});
        }
      }
      calender.push(week);
      return calender;
    };

    const getMessage = () => {
      return (
        <div className='ProgressWorkDatesDialog__body' ref={this.dialog}>
          <div className='label__header'>
            <span className='label__header--type-jobs'>
              工種：{this.state.mainWorkName}{' '}
              {_.isEmpty(this.state.subWorkName)
                ? ''
                : `- ${this.state.subWorkName}`}
            </span>
            {!_.isEmpty(this.state.workPlaceName) && (
              <span className='label__header--location'>{`場所：${
                this.state.workPlaceName
              }`}</span>
            )}
            <span className='label__header--date'>
              計画工期：{`${this.state.start_date} ~ ${this.state.end_date}`}
            </span>
          </div>
          <div className='calender-header'>
            <div className='calender-header__prev-month'>
              <button
                className={`btn--sm--stay ${
                  this.state.currentMonth === startMonth &&
                  this.state.currentYear === startYear
                    ? 'btn--disabled'
                    : ''
                }`}
                onClick={e => this.handleMoveCalendar(e, -1)}
                disabled={
                  this.state.currentMonth === startMonth &&
                  this.state.currentYear === startYear
                }
              >
                &lt; 前月
              </button>
            </div>
            <div className='calender-header__title'>
              {this.state.currentYear} / {this.state.currentMonth}
            </div>
            <div className='calender-header__next-month'>
              <button
                className={`btn--sm--stay ${
                  this.state.currentMonth === endMonth &&
                  this.state.currentYear === endYear
                    ? 'btn--disabled'
                    : ''
                }`}
                onClick={e => this.handleMoveCalendar(e, 1)}
                disabled={
                  this.state.currentMonth === endMonth &&
                  this.state.currentYear === endYear
                }
              >
                翌月 &gt;
              </button>
            </div>
          </div>
          <div className='calender-body'>
            <table className='calender'>
              <thead>
                <tr className='calender__label'>
                  {DAY_OF_WEEK.map((dayWeek, index) => (
                    <th key={index} className='calender__day'>
                      <div className='calender-label'>
                        <div className='calender-label__day'>{dayWeek}</div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody id='work-calender-body'>
                {this.state.workDates &&
                  calenderDateList().map((weekRow, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={`calender__week sys-row${rowIndex}`}
                    >
                      {weekRow.map((dateData, index) => {
                        if (dateData.key >= 0) {
                          return (
                            <td
                              key={`key__rowIndex-${rowIndex}-index-${index}`}
                              className='calender__day'
                            >
                              <label
                                id={`work-click-${dateData.key}`}
                                htmlFor={`calender-${dateData.key}`}
                                onClick={e => this.onClickDate(e, dateData.key)}
                                className={
                                  this.state.today.year === dateData.year &&
                                  this.state.today.month === dateData.month &&
                                  this.state.today.date === dateData.date
                                    ? `calender-day sys-enable-col-${
                                        dateData.key
                                      } enable today`
                                    : `calender-day sys-enable-col-${
                                        dateData.key
                                      } enable`
                                }
                              >
                                <input
                                  type='checkbox'
                                  readOnly
                                  checked={
                                    this.state.workDates[dateData.key]
                                      .holiday_flag === 0
                                      ? true
                                      : false
                                  }
                                  className='sys-row-1 sys-col-3'
                                />
                                <div className='calender-day__number'>
                                  <p
                                    className={
                                      dateData.month < this.state.today.month ||
                                      (dateData.month ===
                                        this.state.today.month &&
                                        dateData.date < this.state.today.date)
                                        ? 'previousDay'
                                        : ''
                                    }
                                  >
                                    {dateData.date}
                                  </p>
                                </div>
                              </label>
                            </td>
                          );
                        } else {
                          return (
                            <td
                              key={`key__rowIndex-${rowIndex}-index-${index}`}
                              className='calender__day'
                            >
                              <label
                                htmlFor={`calender-${index}`}
                                className={`calender-day sys-enable-col-${index}`}
                              >
                                <input
                                  id={`work-calender--${index}`}
                                  type='checkbox'
                                  checked={false}
                                />
                                <div className='calender-day__number'>-</div>
                              </label>
                            </td>
                          );
                        }
                      })}
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className='calender-footer'>
              <ul className='calender-footer__menu'>
                <li>
                  <span className='color-chip--inactive' />
                  <span className='label'>非稼働日</span>
                </li>
                <li>
                  <span className='color-chip--active' />
                  <span className='label'>稼働日</span>
                </li>
                <li>
                  <span className='color-chip--success' />
                  <span className='label'>本日</span>
                </li>
              </ul>
              <p className='label'>
                ※カレンダーの日付をクリックすると、稼働日/非稼働日を切り替えられます。
              </p>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Information
        rootClassName='ProgressWorkDatesDialog'
        visible={this.props.visible}
        message={getMessage()}
        title='稼働日の変更'
        buttonText='決定'
        buttonClassName='btn'
        onClose={this.handleCloseDialog}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/ProgressWorkDatesDialog.jsx